import { createSlice } from '@reduxjs/toolkit';

import { SUPPORTED_LANGUAGES } from '@shared/config/i18n';

const validateLanguage = (lang) => (SUPPORTED_LANGUAGES.includes(lang) ? lang : null);

export const initialState = {
	currentLanguage: null,
};

const languageSlice = createSlice({
	name: 'language',
	initialState,
	reducers: {
		setLanguage: (state, action) => {
			const lang = validateLanguage(action.payload);
			if (lang) {
				state.currentLanguage = lang;
			}
		},
	},
});

export const { setLanguage } = languageSlice.actions;
export const languageReducer = languageSlice.reducer;
